import React from 'react'
import { OrderInfo } from './type'
import { Button, Col, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { isFullyRefunded } from '../utils'

interface FulfilledType {
  order: OrderInfo
  setShowRefundForm: () => void
}

const Fulfilled = ({ order, setShowRefundForm }: FulfilledType) => {
  const fullyRefunded = isFullyRefunded(order)

  return (
    <Col>
      {!fullyRefunded && (
        <>
          <Tooltip
            title={
              <a
                href='https://support.slerp.com/knowledge/processing-a-refund'
                target='_blank'
                rel='noopener noreferrer'
              >
                Refunding and Cancelling Orders
              </a>
            }
            color='#8c8ca1'
          >
            <QuestionCircleOutlined className='_mr-16 _link-white' />
          </Tooltip>
          <Button
            data-testid='order-info-actions-refund'
            title='refund'
            type='primary'
            onClick={() => setShowRefundForm(true)}
            ghost
          >
            Refund
          </Button>
        </>
      )}
    </Col>
  )
}

export default Fulfilled
